import { useTranslation } from "react-i18next";
import { Button, Group } from "@mantine/core";
import { Questionnaire } from "src/graphql/generated/graphql";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { useCampaignApplications } from "../../../../hooks/campaignApplications";
import { ExportCampaignApplicationsXLSXModal } from "../../../../modals/ExportCampaignApplicationsXLSX";
import { CampaignApplicationsDataGrid } from "../../../CampaignApplicationsDataGrid";
import { Pagination } from "../../../Pagination";

export interface CampaignApplicationsTabProps {
    campaign: CampaignQueryDataType;
    questionnaire: Questionnaire;
}

export const CampaignApplicationsTab = ({ campaign, questionnaire }: CampaignApplicationsTabProps) => {
    const { t } = useTranslation(["common"]);

    const campaignApplicationsHook = useCampaignApplications(campaign?.id);

    return (
        <>
            <Group mb="md" position="right">
                <Button
                    radius={8}
                    variant="default"
                    onClick={() =>
                        ExportCampaignApplicationsXLSXModal.display({
                            campaign,
                            campaignApplications: campaignApplicationsHook?.allCampaignApplications || [],
                        })
                    }
                >
                    {t("campaignapplication_bulk_downloadxlsx")}
                </Button>
            </Group>
            <CampaignApplicationsDataGrid {...campaignApplicationsHook} questionnaire={questionnaire} />
            <Pagination mt="md" {...campaignApplicationsHook?.campaignApplicationsPagination} />
        </>
    );
};
